var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"icon ml-1",attrs:{"viewBox":"0 0 8 8"}},[_c('use',{attrs:{"xlink:href":_vm.href}})])
}
var staticRenderFns = []

export { render, staticRenderFns }